import React from 'react';

export default function ReadOnlyCell({ value }) {
  if (value === '' || value === null || value === undefined) return <span />;
  return <span>{String(value)}</span>;
}
